import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { parseIcon } from '@gov-nx/component/common';
import type { CookbookListCoreProps } from '@gov-nx/ui/types';
import { scrollToElement } from '@gov-nx/web';
import { CookbookContainer } from './CookbookContainer';
import { CookbookItem } from './CookbookItem';

export const CookbookList = ({ label, items }: CookbookListCoreProps) => {
	const location = useLocation();

	useEffect(() => {
		if (location.hash) {
			const elementId = location.hash.replace('#', '');
			const element = document.getElementById(elementId);
			scrollToElement(element);
		}
	}, [location.hash]);

	return (
		<CookbookContainer label={label}>
			{items.map(({ id, text, icon }) => (
				<CookbookItem
					key={id}
					icon={icon?.icon ? parseIcon(icon.icon) : null}
					copy={text}
				/>
			))}
		</CookbookContainer>
	);
};
